import React, { useEffect, useMemo, useState } from 'react';
import { ScrollView, Text, View } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CustomTextInput } from '../../components/customTextInput';
import { useTranslation } from 'react-i18next';
import ActivitiesDynamicForm from './activitiesDynamicForm';
import CustomPressable from '../../components/customPressable/customPressable';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { ADD, MINUS } from '../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';

const ActivitiesAdditionalDetails = (props) => {
    const { selectedEvent, participantCount, handleUpdatedSelectedEventObj, handleNext, handleGoBack, getPriceTierName } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [defaultQuestions, setDefaultQuestions] = useState( selectedEvent.defaultQuestions);
    const [purchaserAnswers, setPurchaserAnswers] = useState([]);
    const [participantAnswers, setParticipantAnswers] = useState(Array.from({ length: participantCount }, () => []));

    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);

    // Load saved answers on mount
    useEffect(() => {
        if (selectedEvent?.purchaserAnswers) {
            setPurchaserAnswers(selectedEvent.purchaserAnswers);
        }
        if (selectedEvent?.participantAnswers) {
            setParticipantAnswers(selectedEvent.participantAnswers);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Filter questions by scope
    const purchaserQuestions = useMemo(
        () => selectedEvent?.eventInfo?.customQuestions?.filter(
            q => q.config?.scope === "purchaser"
        ) || [],
        [selectedEvent]
    );

    const participantQuestions = useMemo(
        () => selectedEvent?.eventInfo?.customQuestions?.filter(
            q => q.config?.scope === "participant"
        ) || [],
        [selectedEvent]
    );

    console.log("purchaser questions : ", purchaserQuestions, currentGuestDetails)

    const handleAnswerChange = (answerObj, scope, participantIndex = null) => {
        if (scope === "purchaser") {
            setPurchaserAnswers(prev => {
                const existingIndex = prev.findIndex(a => a.questionId === answerObj.questionId);
                if (existingIndex >= 0) {
                    const updated = [...prev];
                    updated[existingIndex] = answerObj;
                    return updated;
                }
                return [...prev, answerObj];
            });
        } else if (scope === "participant" && participantIndex !== null) {
            setParticipantAnswers(prev => {
                const updated = [...prev];
                const answers = [...(updated[participantIndex] || [])];
                const existingIndex = answers.findIndex(a => a.questionId === answerObj.questionId);
                if (existingIndex >= 0) {
                    answers[existingIndex] = answerObj;
                } else {
                    answers.push(answerObj);
                }
                updated[participantIndex] = answers;
                return updated;
            });
        }
    };

    const handleDefaultQuestionsUpdate = ({ isParticipant, participantNumber, key, value }) => {
        setDefaultQuestions(prev => {
            const updated = JSON.parse(JSON.stringify(prev));
            if (isParticipant) {
                updated.participants[participantNumber][key] = value;
            } else {
                updated.purchaser[key] = value;
            }
            return updated;
        });
    };

    const onAddOnQuantityUpdate = (id, change) => {
        const updatedAddons = selectedEvent.addOns?.map(addOn => {
            if (addOn.id !== id) return addOn;
            
            const newQuantity = addOn.quantity + change;
            if (newQuantity < 0 || newQuantity > addOn.maxQuantity) {
                return addOn;
            }
            
            return {
                ...addOn,
                quantity: newQuantity
            };
        });

        handleUpdatedSelectedEventObj({ addOns: updatedAddons });
    };

    const handleBack = () => {
        handleUpdatedSelectedEventObj({
            participantAnswers,
            purchaserAnswers,
            defaultQuestions
        });
        handleGoBack();
    };

    const requiredCheck = (questions, answers) => {
        if (!questions?.length) return true;

        for (const question of questions) {
            if (question.config?.isRequired && !question.config?.disabled) {
                const answer = answers.find(a => question.id === a.questionId);

                if (!answer?.answer?.[0]?.value) {
                    dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter all the mandatory fields to proceed" }));
                    return false;
                }
            }
        }

        return true;
    };

    const handleProceed = () => {
        const isPurchaserValid = requiredCheck(purchaserQuestions, purchaserAnswers);
        const isParticipantsValid = requiredCheck(participantQuestions, participantAnswers);

        if (isPurchaserValid && isParticipantsValid) {
            handleUpdatedSelectedEventObj({
                participantAnswers,
                purchaserAnswers,
                defaultQuestions
            });
            handleNext();
        }
    };

    return (
        <View
            style={getStyles([
                'widgetRootContainer',
                'activitiesAdditionlaDetailsRootContainer'
            ])}
            id='activitiesAdditionlaDetailsRootContainer'
        >
            <HeaderWithBack handleCustomBackPress={handleBack} />

            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles([ 'widgetmainContainer', 'activitiesAdditionlaDetailsMainContainer' ])} showsVerticalScrollIndicator={false} id='activitiesCreateBookingMainContainer'>
                <View style={getStyles([ 'widgetmainContainerHeaderTitleContainer', 'activitiesAdditionlaDetailsHeaderTitleContainer' ])} id='activitiesAdditionlaDetailsHeaderTitleContainer' >
                    <Text style={getStyles([ 'widgetmainContainerHeaderTitle', 'activitiesAdditionlaDetailsHeaderTitle' ])} id='activitiesAdditionlaDetailsHeaderTitle' >
                        {t("way_activity.additional_details.heading")}
                    </Text>

                    <Text style={getStyles([ 'widgetmainContainerHeaderSubTitle', 'activitiesAdditionlaDetailsHeaderSubTitle' ])} id='activitiesAdditionlaDetailsHeaderSubTitle' >
                        {t("way_activity.additional_details.subheading")}
                    </Text>
                </View>

                <View style={getStyles([ 'widgetmainContainerChildContainer', 'activitiesCreateBookingMainContainerChildContainer' ])} id='activitiesCreateBookingMainContainerChildContainer' >
                    {/* AddOns Section */}
                    {selectedEvent?.addOns?.length > 0 && (
                        <View style={getStyles(['activitiesCreateBookingAddonContainer'])} id='activitiesCreateBookingAddonContainer' >
                            <Text style={getStyles(['activitiesCreateBookingAddonHeading'])} id='activitiesCreateBookingAddonHeading' >
                                {t("way_activity.additional_details.add_on")}
                            </Text>

                            {selectedEvent.addOns.map(addon => (
                                <View style={getStyles([ 'list_itemContainer', 'activitiesCreateBookingItemContainer' ])} id='activitiesCreateBookingItemContainer' key={addon.id} >
                                    <View style={getStyles([ 'list_itemContainer_textContainer', 'activitiesCreateBookingItemTextContainer' ])} id='activitiesCreateBookingItemTextContainer' >
                                        <Text style={getStyles(['activitiesCreateBookingItemLabel'])} id='activitiesCreateBookingItemLabel' >
                                            {addon.label}
                                        </Text>
                                        <Text style={getStyles(['activitiesCreateBookingItemSubText'])} id='activitiesCreateBookingItemSubText' >
                                            {`${selectedEvent?.eventInfo?.currency} ${addon.price}`}
                                        </Text>
                                    </View>

                                    <View style={getStyles(['activitiesCreateBookingButtonContainer'])} id='activitiesCreateBookingButtonContainer' >
                                        <CustomPressable
                                            disabled={addon.quantity <= 0}
                                            style={getStyles(['activitiesCreateBookingButtonMinusContainer'])}
                                            onPress={() => onAddOnQuantityUpdate(addon.id, -1)}
                                            id="activitiesCreateBookingButtonMinusContainer"
                                        >
                                            <ImageComp
                                                source={MINUS}
                                                style={getStyles(['activitiesCreateBookingButtonAddMinus'])}
                                                id="activitiesCreateBookingButtonAddMinus"
                                            />
                                        </CustomPressable>

                                        <Text
                                            style={getStyles(['activitiesCreateBookingButtonQuantityText'])}
                                            id='activitiesCreateBookingButtonQuantityText'
                                        >
                                            {addon.quantity}
                                        </Text>

                                        <CustomPressable
                                            disabled={addon.quantity >= addon.maxQuantity}
                                            style={getStyles(['activitiesCreateBookingButtonAddContainer'])}
                                            onPress={() => onAddOnQuantityUpdate(addon.id, 1)}
                                            id="activitiesCreateBookingButtonAddContainer"
                                        >
                                            <ImageComp
                                                source={ADD}
                                                style={getStyles(['activitiesCreateBookingButtonAddMinus'])}
                                                id="activitiesCreateBookingButtonAddMinus"
                                            />
                                        </CustomPressable>
                                    </View>
                                </View>
                            ))}
                        </View>
                    )}

                    {/* Purchaser Form */}
                    {purchaserQuestions.length > 0 && (
                        <View
                            style={getStyles(['activitiesDynamicFormContainer'])}
                            id='activitiesDynamicFormContainer'
                        >
                            {purchaserQuestions.map(q => (
                                <ActivitiesDynamicForm
                                    key={q.id}
                                    question={q}
                                    answers={purchaserAnswers}
                                    guestDetails={currentGuestDetails?.guestProfile}
                                    onAnswerChange={a => handleAnswerChange(a, "purchaser")}
                                />
                            ))}
                        </View>
                    )}

                    {/* Participants Form */}
                    {participantCount > 0 && (
                        <View
                            style={getStyles(['activitiesDynamicFormContainer'])}
                            id='activitiesDynamicFormContainer'
                        >
                            <Text
                                style={getStyles(['activitiesDynamicFormContainerText'])}
                                id='activitiesDynamicFormContainerText'
                            >
                                {t("way_activity.additional_details.participants.heading")}
                            </Text>

                            {[...Array(participantCount)].map((_, index) => (
                                <View
                                    key={index}
                                    style={getStyles(['activitiesDynamicFormItemContainer'])}
                                    id='activitiesDynamicFormItemContainer'
                                >
                                    <Text
                                        style={getStyles(['activitiesDynamicFormItemContainerHeading'])}
                                        id='activitiesDynamicFormItemContainerHeading'
                                    >
                                        {`Guest #${index + 1} (Price tier: ${getPriceTierName()[index]})`}
                                    </Text>

                                    <View style={getStyles(['textContainer'])} id='textContainer'>
                                        <Text style={getStyles(['label'])} id='label'>
                                            {t("way_activity.additional_details.participants.first_name")}
                                        </Text>
                                        <CustomTextInput
                                            value={defaultQuestions.participants[index].firstName}
                                            onChangeText={text =>
                                                handleDefaultQuestionsUpdate({
                                                    isParticipant: true,
                                                    participantNumber: index,
                                                    key: "firstName",
                                                    value: text
                                                })
                                            }
                                        />
                                    </View>

                                    <View style={getStyles(['textContainer'])} id='textContainer'>
                                        <Text style={getStyles(['label'])} id='label'>
                                            {t("way_activity.additional_details.participants.last_name")}
                                        </Text>
                                        <CustomTextInput
                                            value={defaultQuestions.participants[index].lastName}
                                            onChangeText={text =>
                                                handleDefaultQuestionsUpdate({
                                                    isParticipant: true,
                                                    participantNumber: index,
                                                    key: "lastName",
                                                    value: text
                                                })
                                            }
                                        />
                                    </View>

                                    {participantQuestions.map(q => (
                                        <ActivitiesDynamicForm
                                            key={q.id}
                                            question={q}
                                            answers={participantAnswers[index] || []}
                                            onAnswerChange={a => handleAnswerChange(a, "participant", index)}
                                        />
                                    ))}
                                </View>
                            ))}
                        </View>
                    )}
                </View>
            </ScrollView>

            <View
                id='activitiesBookingNextButtonContainer'
                style={getStyles(['activitiesBookingNextButtonContainer'])}
            >
                <CustomPressable
                    style={getStyles(['primaryBtn'])}
                    onPress={handleProceed}
                    id="primaryBtn"
                >
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t('way_activity.additional_details.button')}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    );
};

export default ActivitiesAdditionalDetails;